/**
 * File Name          : data-collection.component.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { Component, Input } from '@angular/core';
import { DatasnapDevice, DatasnapDeviceStatus } from '../../models/datasnap-device.model';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxPopupComponent, DxPopupModule, DxProgressBarComponent } from 'devextreme-angular';
import { ViewChild } from '@angular/core';
import { DatasnapDeviceService } from '../../services/datasnap-device.service';
import { DeviceFileSubscription } from '../../../../projects/idl-physens/src/lib/models/subscription/device-file-sub.model';
import { Device_State } from '../../../../projects/idl-physens/src/lib/models/physens-devices/physens-device.model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { confirm, alert } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-data-collection',
  standalone: true,
  imports: [CommonModule, DxButtonModule, DxProgressBarComponent, DxPopupModule],
  templateUrl: './data-collection.component.html',
  styleUrl: './data-collection.component.scss'
})
export class DataCollectionComponent {
  @Input() device!: DatasnapDevice;
  @Input() subs!: DeviceFileSubscription[];
  @ViewChild('fwUpdatePopup') fwUpdatePopup?: DxPopupComponent;

  unitId!: string;
  levelId!: string;
  lessonId!: string;

  // fwUpdatePromptDismissed: boolean = false;
  // private routerEventsSub?: Subscription;

  DatasnapDeviceStatus = DatasnapDeviceStatus;
  Device_State = Device_State;

  constructor(private datasnapDeviceService: DatasnapDeviceService, private router: Router, private activatedRoute: ActivatedRoute, ) { }


  ngOnInit() {
      // Subscribe to router events to detect navigation changes
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        this.updateFromRoute();
      });
  
      // Initial load
      this.updateFromRoute();
  }

  private updateFromRoute() {
    // Access the deepest child route to get all params
    let child = this.activatedRoute;
    while (child) {
      if (child.firstChild) {
        child = child.firstChild;
      } else {
        this.unitId = this.activatedRoute.snapshot.paramMap.get('unitId') ?? '';
        this.levelId = this.activatedRoute.snapshot.paramMap.get('levelId') ?? '';
        this.lessonId = this.activatedRoute.snapshot.paramMap.get('lessonId') ?? '';

        // this.routerEventsSub = this.router.events.pipe(
        //   filter(event => event instanceof NavigationEnd)
        // ).subscribe(() => {
        //   if (this.isLessonRoute(this.router.url)) {
        //     this.fwUpdatePromptDismissed = false;
        //   }
        // });
        
        break;
      }
    }
  }


  // ngOnDestroy(): void {
  //   this.routerEventsSub?.unsubscribe();
  // }

  // private isLessonRoute(url: string): boolean {
  //   return /^\/home\/[^/]+\/[^/]+\/[^/]+$/.test(url);
  // }

  showFWUpdatePopup = (): boolean => {
    return this.device.isFWOutOfDate
      && !this.device.updateFailed
      // && !this.fwUpdatePromptDismissed
      && !this.router.url.includes('/firmware-update/');
  }

  showSelectDevicePopup = (): boolean => {
    return this.device.hasDevice
      && this.device.needsReselect
  }

  startRecording = () => {
    this.device.startRecording(this.subs);
  }

  stopRecording = () => {
    this.device.stopRecording();

    this.getRecording();
  }

  getRecording = () => {

    
  }

  downloadData = () => {
    this.device.downloadAnalyzedData()
  }
  downloadRawData = () => {
    this.device.downloadRawData()
  }

  clearRecording = () => {
    this.device.clearRecording()
    this.datasnapDeviceService.clearDisconnectedDevices();
  }

  rebootDevice = () => {
    confirm("This will restart your DataSnap. Any recording in progress or not yet downloaded may be lost. Continue?", "Reboot DataSnap").then((confirmed) => {
      if(!confirmed) return;
      this.datasnapDeviceService.rebootDevice(this.device).then(() => {
        alert("Your DataSnap is restarting. Wait a few seconds, then reconnect it.", "Reboot DataSnap");
      }).catch((err) => {
        console.error("Failed to reboot DataSnap:", err);
        alert("Could not reboot the DataSnap. Please try again.", "Reboot DataSnap");
      });
    });
  }

  selectNewDevice = () => {
    let unitId = this.device.unitId;
    this.datasnapDeviceService.removeDevice(this.device);
    this.datasnapDeviceService.addNewDevice(unitId);
    
  }

  retryConnection = () => {
    this.device.setStatus(DatasnapDeviceStatus.IDLE);
    this.device.retryConnection();
  }

  getTriggerImgPath = () => {
    if(this.device.unitId === 'impact') return '/assets/triggers/Impact_Trigger.svg'
    if(this.device.unitId === 'air_racer') return '/assets/triggers/AirRacer_Trigger.svg'
    if(this.device.unitId === 'projectile') return '/assets/triggers/Projectile_Trigger.svg'
    return ''
  }

  initiateFWUpdate = () => {
    // this.fwUpdatePromptDismissed = true;
    this.fwUpdatePopup?.instance.hide();
    this.router.navigate(['home', 'firmware-update', this.device.deviceId??'1'], { state: {
      unitId: this.unitId,
      levelId: this.levelId,
      lessonId: this.lessonId
    }});
  }

  reselectDevice = async () => {
    await this.datasnapDeviceService.reselectDevice(this.device);
  }
}
